<template>
    <div class="main">
        <h1>预约成功，我们会尽快与您联系！</h1>
        <div class="content">
            <div class="sm">【预约说明】</div>
            <p> 1.请合理安排您的预约时间，按时体检。</p>
            <p> 2.若需改约，请提前24小时致电客服改约，联系电话：0512-56995618，谢谢。</p>
            <!-- <p>3.如正在服药应及时转告检查医师，防止影响检查结果。</p>
            <p> 4.颈部请勿戴项链和挂件，勿穿带有尼龙丝或金属的衣物。</p> -->
        </div>
        <div class="btn">
            <button type="button" @click="fanhui">返回</button>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            fanhui() {
                this.$router.push({
                    path: '/home'
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .main {
        padding: 8rem 0;
        font-size: 0.8rem;
        h1 {
            font-size: 1rem;
            color: #43852E;
            text-align: center;
            line-height: 2rem;
            font-family: 'Arial Normal', 'Arial';
            font-weight: 400;
            height: 4rem;
        }
        .content {
            margin-bottom: 3rem;
            p {
                margin: 0 2em;
                line-height: 1.5rem;
                text-indent: 2em;
            }
            .sm {
                margin: 0 2em;
                line-height: 1.5rem;
                color: #43852E;
            }
        }
        .btn {
            text-align: center;
        }
        button {
            background-color:#43852E;
            border: none;
            border-radius: 5px;
            box-shadow: none;
            height: 2.4rem;
            text-align: center;
            color: #ffffff;
            width: 7rem;
            height: 2.4rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/yycg.vue